





















import { Vue, Component } from 'vue-property-decorator'
@Component({
  name: 'FilesApp'
})
export default class extends Vue {
  showNav: boolean = true

  get editPage() {
    const activeArr: string[] = ['AddApp', 'EditApp']
    return activeArr.includes(this.$route.name as string)
  }
}
